export default __webpack_public_path__ + "static/media/bkg--location-1-2.f245de73.jpg";